import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../../shared/shared.module";
import {
  GroupDetailsScreenComponent
} from './screens/group-details-screen/group-details-screen.component';
import {
  GroupSessionsScreenComponent
} from './screens/group-sessions-screen/group-sessions-screen.component';
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/group-details.reducer";
import {EffectsModule} from "@ngrx/effects";
import {GroupDetailsEffects} from "./core/group-details.effects";
import {FormsModule} from "@angular/forms";
import {
  GroupDetailsScreenContainerComponent
} from './container/group-details-screen-container.component';
import {
  GroupDetailsScreenShimmerLoaderComponent
} from './components/group-details-screen-shimmer-loader/group-details-screen-shimmer-loader.component';


@NgModule({
  declarations: [
    GroupDetailsScreenComponent,
    GroupSessionsScreenComponent,
    GroupDetailsScreenContainerComponent,
    GroupDetailsScreenShimmerLoaderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature("ss-cord.group-details", reducer),
    EffectsModule.forFeature(
      [GroupDetailsEffects]
    ),
    FormsModule,
  ]
})
export class GroupDetailsModule {
}
